/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Workout_Live_Implausible_TitleInputs */

const en_us2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Did you really lift ${i?.value}?`)
};

const pt_br2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você levantou mesmo ${i?.value}?`)
};

const es_419_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿De verdad levantaste ${i?.value}?`)
};

const pt_pt2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantaste mesmo ${i?.value}?`)
};

const fr_fr2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as vraiment soulevé ${i?.value} ?`)
};

const de_de2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wirklich ${i?.value} bewegt?`)
};

const it_it2_workout_live_implausible_title = /** @type {(inputs: Workout_Live_Implausible_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai sollevato davvero ${i?.value}?`)
};

/**
* | output |
* | --- |
* | "Did you really lift {value}?" |
*
* @param {Workout_Live_Implausible_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_title = /** @type {((inputs: Workout_Live_Implausible_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_title(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_title(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_title(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_title(inputs)
	return en_us2_workout_live_implausible_title(inputs)
});
export { workout_live_implausible_title as "workout-live.implausible_title" }